const base = "https://rank.pauloferraco.com.br/"
export {base}
